import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { GlobalStyle } from "./GlobalStyle";
import { ThemeProvider } from "styled-components";
import Home from "./Home";
import About from "./About"
import Products from "./Products"
import SingleProduct from "./SingleProduct"
import ErrorPage from "./ErrorPage"
import Contact from "./Contact"
import Cart from "./Cart"
import Header from "./components/Header";
import Footer from "./components/Footer";

const App = () => {

  const theme = {
    colors: {
      heading: "rgb(24 24 29)",
      text: "rgba(29 ,29, 29, .8)",
      white: "#fff",
      black: " #212529",
      helper: "#f58a20",

      bg: "#F6F8FA",
      footer_bg: "#0a1435",
      btn: "#fc7f03",
      border: "rgba(245, 171, 98)",
      hr: "#ffffff",
      gradient:
        "linear-gradient(0deg, rgb(132 144 255) 0%, rgb(98 189 252) 100%)",
      shadow:
        "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;",
      shadowSupport: " rgba(0, 0, 0, 0.16) 0px 1px 4px",
    },
    media: {
      mobile: "768px",
      tab: "998px",
    },
  };
  
  return (
  <>
  <ThemeProvider theme={theme}>
  <GlobalStyle/>
  <Router>
  <Header/>
    <Routes>
      <Route path="/" element={<Home/>} />
      <Route path="/about" element={<About/>} />
      <Route path="/products" element={<Products/>} />
      <Route path="/contact" element={<Contact/>} />
      <Route path="/singleproduct/:id" element={<SingleProduct/>} />
      <Route path="/cart" element={<Cart/>} />
      <Route path="*" element={<ErrorPage/>} />
    </Routes>
    <Footer/>
  </Router>
  </ThemeProvider>
  
  </>);
};

export default App;
